import MediaQuery from 'react-responsive';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import * as actions from '../actions';
import homeImage from './assets/IMG_1099-5-cropped.jpg';

class Home extends Component {
	state = {};

	render() {
		return (
			<div className="row">
				<Helmet>
					<title>George Kanchev</title>
					<meta name="description" content={'Software Developer'} />
				</Helmet>
				<MediaQuery maxWidth="991px">
					<div
						className="col-lg-6"
						style={{
							height: 'calc(0.63 * 100vh)',
							background: `url(${homeImage}) no-repeat center top`,
							backgroundSize: 'cover',
							WebkitBackgroundSize: 'cover',
							MozBackgroundSize: 'cover',
							OBackgroundSize: 'cover',
							marginTop: 'calc(0.1 * 100vh)',
						}}
					/>
				</MediaQuery>
				<MediaQuery minWidth="992px">
					<div
						className="col-lg-6 border-sm-none border-xs-none"
						style={{
							height: 'calc(0.63 * 100vh)',
							background: `url(${homeImage}) no-repeat  center top`,
							backgroundSize: 'cover',
							WebkitBackgroundSize: 'cover',
							MozBackgroundSize: 'cover',
							OBackgroundSize: 'cover',
							borderRight: '8px solid #000',
							marginTop: 'calc(0.1 * 100vh)',
						}}
					/>
					<div
						className="col-lg-6"
						style={{
							background: '#a9adb0',
							height: 'calc(0.63 * 100vh)',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							flexDirection: 'column',
							borderLeft: '8px solid #000',
							marginTop: 'calc(0.1 * 100vh)',
						}}
					>
						<h1
							style={{
								fontSize: '5vw',
								textTransform: 'uppercase',
								// letterSpacing: "-2px",
								fontFamily: 'Avant Garde, Avantgarde, Century Gothic, CenturyGothic, AppleGothic, sans-serif',
								fontWeight: 'bold',
								borderBottom: '25px solid rgba(255,255,255,0.5)',
							}}
						>
							<span
								style={{
									// color: '#3C7DC4',
									color: '#707088',
									// opacity: "0.5"
								}}
							>
								George
							</span>
							<span
								style={{
									color: '#EDEBEC',
									// opacity: "0.5",
									fontWeight: 'light',
								}}
							>
								kanchev
							</span>
						</h1>
						<h2
							style={{
								fontSize: '3vw',
								color: 'white',
								opacity: '0.5',
								// letterSpacing: "30px",
								fontFamily: 'Avant Garde, Avantgarde, Century Gothic, CenturyGothic, AppleGothic, sans-serif',
							}}
						>
							Software Developer
						</h2>
					</div>
				</MediaQuery>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {};
}

export default withRouter(
	connect(
		mapStateToProps,
		actions,
	)(Home),
);



// WEBPACK FOOTER //
// ./src/components/Home.js